var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopylinkqrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qr-code"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.625 16.25H16.625C16.4179 16.25 16.25 16.4179 16.25 16.625V19.625C16.25 19.8321 16.4179 20 16.625 20H19.625C19.8321 20 20 19.8321 20 19.625V16.625C20 16.4179 19.8321 16.25 19.625 16.25Z",
    fill: "#8493B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.875 13.25H13.625C13.4179 13.25 13.25 13.4179 13.25 13.625V15.875C13.25 16.0821 13.4179 16.25 13.625 16.25H15.875C16.0821 16.25 16.25 16.0821 16.25 15.875V13.625C16.25 13.4179 16.0821 13.25 15.875 13.25Z",
    fill: "#8493B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.625 20H20.375C20.1679 20 20 20.1679 20 20.375V22.625C20 22.8321 20.1679 23 20.375 23H22.625C22.8321 23 23 22.8321 23 22.625V20.375C23 20.1679 22.8321 20 22.625 20Z",
    fill: "#8493B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.625 13.25H21.125C20.9179 13.25 20.75 13.4179 20.75 13.625V15.125C20.75 15.3321 20.9179 15.5 21.125 15.5H22.625C22.8321 15.5 23 15.3321 23 15.125V13.625C23 13.4179 22.8321 13.25 22.625 13.25Z",
    fill: "#8493B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.125 20.75H13.625C13.4179 20.75 13.25 20.9179 13.25 21.125V22.625C13.25 22.8321 13.4179 23 13.625 23H15.125C15.3321 23 15.5 22.8321 15.5 22.625V21.125C15.5 20.9179 15.3321 20.75 15.125 20.75Z",
    fill: "#8493B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.625 5H16.625C16.4179 5 16.25 5.16789 16.25 5.375V8.375C16.25 8.58211 16.4179 8.75 16.625 8.75H19.625C19.8321 8.75 20 8.58211 20 8.375V5.375C20 5.16789 19.8321 5 19.625 5Z",
    fill: "#8493B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 3.5C13.25 2.67157 13.9216 2 14.75 2H21.5C22.3284 2 23 2.67157 23 3.5V10.25C23 11.0784 22.3284 11.75 21.5 11.75H14.75C13.9216 11.75 13.25 11.0784 13.25 10.25V3.5ZM21.5 3.5H14.75V10.25H21.5V3.5Z",
    fill: "#8493B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.375 5H5.375C5.16789 5 5 5.16789 5 5.375V8.375C5 8.58211 5.16789 8.75 5.375 8.75H8.375C8.58211 8.75 8.75 8.58211 8.75 8.375V5.375C8.75 5.16789 8.58211 5 8.375 5Z",
    fill: "#8493B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.5C2 2.67157 2.67157 2 3.5 2H10.25C11.0784 2 11.75 2.67157 11.75 3.5V10.25C11.75 11.0784 11.0784 11.75 10.25 11.75H3.5C2.67157 11.75 2 11.0784 2 10.25V3.5ZM10.25 3.5H3.5V10.25H10.25V3.5Z",
    fill: "#8493B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.375 16.25H5.375C5.16789 16.25 5 16.4179 5 16.625V19.625C5 19.8321 5.16789 20 5.375 20H8.375C8.58211 20 8.75 19.8321 8.75 19.625V16.625C8.75 16.4179 8.58211 16.25 8.375 16.25Z",
    fill: "#8493B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14.75C2 13.9216 2.67157 13.25 3.5 13.25H10.25C11.0784 13.25 11.75 13.9216 11.75 14.75V21.5C11.75 22.3284 11.0784 23 10.25 23H3.5C2.67157 23 2 22.3284 2 21.5V14.75ZM10.25 14.75H3.5V21.5H10.25V14.75Z",
    fill: "#8493B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopylinkqrCode);
export default __webpack_public_path__ + "static/media/copylinkqr-code.647fe47132cce78e5b588615d83cca35.svg";
export { ForwardRef as ReactComponent };